import type { SceneState } from '@/lib/studio/studioState';

const MIN = 60_000;

/**
 * Minutes left on the build at the pace the built scenes took, once every scene left has started: they build side by
 * side, so it is the longest of what is left on each. Null with no built scene to go on, a scene still waiting to start
 * (the order Ivy builds them in is hers), a scene that needs attention, or nothing left. There is no server estimate;
 * this is the client's.
 */
export function buildEta(scenes: SceneState[], now: number): number | null {
  const took = scenes.flatMap((s) => (s.status === 'built' && s.startedAt != null && s.endedAt != null ? [s.endedAt - s.startedAt] : []));
  const left = scenes.filter((s) => s.status !== 'built');
  if (!took.length || !left.length || left.some((s) => s.status !== 'building' || s.startedAt == null)) return null;
  const pace = took.reduce((a, b) => a + b, 0) / took.length;
  const ms = Math.max(...left.map((s) => pace - (now - s.startedAt!)));
  return Math.max(1, Math.ceil(ms / MIN));
}
